<nav class="navbar navbar-default navbar-static-top" role="navigation" style="margin-bottom: 0; padding:0;">
  <div class="navbar-header" style="width:100%">
    <div style="position: absolute; margin:1px 15px 0px 15px;">
      <a routerLink="dashboard">
        <img src="assets/main-logo-white-text.gif" style="width:120px;"/>
      </a>
    </div>
    <a style="margin-left: 120px; padding-top: 19px;" class="navbar-brand" href="/">Water Air Land Territorial
      Electronic Record System</a>

    <div class="navbar-top-links"
         style="display: flex; flex-direction: row; float: right; height: 65px; margin-right: 20px;"
         *ngIf="(user | async) as u">
      <div style="display: flex;
                  flex-direction: column;
                  justify-content: center;">
        <app-help-docs-links></app-help-docs-links>
      </div>
      <div ngbDropdown>
        <button class="btn username-menu" ngbDropdownToggle style="padding: 20.5px;">{{u.name}}</button>
        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
          <a ngbDropdownItem *ngIf="u.is_superuser || u.is_staff" [href]="adminUrl">Administration</a>
          <a ngbDropdownItem (click)="logout()">Logout</a>
        </div>
      </div>
    </div>
    <!--        <ul class="nav navbar-top-links navbar-right" style="float:right; margin-left:78px;">-->

    <!--        &lt;!&ndash; put breadcrumbs here &ndash;&gt;-->

    <!--        <li>-->

    <!--        </li>-->

    <!--        <li class="dropdown" id="userMenu" ngbDropdown style="display: inline-block !important;" *ngIf="(user | async) as u">-->
    <!--            <a type="button" ngbDropdownToggle>-->
    <!--                {{ u.name }}-->
    <!--            </a>-->
    <!--            <ul class="dropdown-menu dropdown-user" id="userMenuItems" ngbDropdownMenu>-->
    <!--                <li *ngIf="u.is_superuser"><a href="/admin/">Administration</a></li>-->
    <!--                <li class="divider"></li>-->
    <!--                <li>-->
    <!--                    <a (click)="logout()"><i class="fa fa-sign-out fa-fw"></i> Logout</a>-->
    <!--                </li>-->
    <!--            </ul>-->
    <!--            &lt;!&ndash; /.dropdown-user &ndash;&gt;-->
    <!--        </li>-->
    <!--        &lt;!&ndash; /.dropdown &ndash;&gt;-->
    <!--    </ul>-->
  </div>
  <!-- /.navbar-header -->


  <!-- /.navbar-top-links -->

  <!-- /.navbar-static-side -->
</nav>
